import { ArmedStructuresPassive } from '../deck-passives/armed_structures.js';
import { EchoingDeploymentPassive } from '../deck-passives/echoing_deployment.js';
import { EnergyReservePassive } from '../deck-passives/energy_reserve.js';
import { RisingDamagePassive } from '../deck-passives/rising_damage.js';
import { SteadyRecoveryPassive } from '../deck-passives/steady_recovery.js';
/** Explicit production manifest; passives never join constructed card slots. */
export const productionDeckPassives = Object.freeze([
    ArmedStructuresPassive,
    EchoingDeploymentPassive,
    EnergyReservePassive,
    RisingDamagePassive,
    SteadyRecoveryPassive,
]);
//# sourceMappingURL=deck-passives.js.map